<template>
    <div class="row">
        <div class="form-group col-sm-8 m-b-40" :class="{ 'has-danger': error }">
            <label for="price">{{ label }}</label>
            <input type="number" name="price" class="form-control" id="price" :placeholder="placeholder" v-model="price" required>
            <div class="form-control-feedback" v-if="error">
                {{ error }}
            </div>
        </div>
        <div class="form-group col-sm-4 m-b-40">
            <label for="conversion">{{ 'general.statistics.views' | lang }}</label>
            <input type="number" name="conversion" class="form-control" id="conversion" :value="conversion" disabled>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            rate: null,
            error: null,
            old: null,
            placeholder: null,
            label: null
        },
        data() {
            return {
                price: this.old || '',
            }
        },
        computed: {
            conversion() {
                return Math.ceil(this.price / this.rate)
            }
        }
    }
</script>
